module.exports = __webpack_public_path__ + "static/img/组 2853.588d55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2853.png
// module id = OIrP
// module chunks = 0